module.exports = {"id":"213135","name":"Divock Origi","rating":"77","photo":"./data/images/photos/3/213135.png","club":{"name":"VfL Wolfsbourg","logo":"./data/images/clubs/VfLWolfsbourg.png"},"positions":["BU","AG","MD"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/DivockOrigi0.json
// module id = 1114
// module chunks = 0